<div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
    <div class="w-full h-full flex flex-col overflow-hidden">
        <div class="flow-root flex-1 min-h-0 overflow-hidden">
            <div class="overflow-x-auto h-full">
                <div class="w-full h-full">
                    <div class="data-table-wrapper h-full flex flex-col overflow-hidden">
                        <div class="flex w-full shrink-0 items-center justify-between gap-x-3 border-b border-[var(--border)] bg-[var(--muted)] px-3 py-2">
                            <div class="grid grid-cols-1 w-1/5">
                                <input id="email" type="email" name="email" placeholder="Keyword Search..."
                                    class="col-start-1 row-start-1 block w-full py-1.5 pr-3 pl-10 input-primary-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round"
                                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-secondary sm:size-4">
                                    <path d="m21 21-4.34-4.34" />
                                    <circle cx="11" cy="11" r="8" />
                                </svg>
                            </div>
                            <ttor-video-metrics [visibleColumns]="visibleColumns()"
                                (columnsChange)="onColumnsChange($event)">
                            </ttor-video-metrics>
                        </div>
                        <div class="overflow-auto flex-1 min-h-0 scrollbar-transparent dark:bg-gray-800/50">
                            <div class="w-max min-w-full">
                                <!-- <table class="data-table min-w-full bg-(--muted)"> -->
                                <table class="data-table min-w-full">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <!-- Fixed columns -->
                                            <th scope="col"
                                                class="sticky left-0 z-20 bg-[var(--muted)] border-r border-[var(--border)] text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Creator</th>
                                            <!-- <th scope="col"
                                                class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Creator
                                            </th> -->
                                            <th scope="col"
                                                class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Created
                                            </th>
                                            <!-- Engagement -->
                                            @if (isVisible('engagement_count')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Engagement Count</th>
                                            }
                                            @if (isVisible('engagement_rate')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Engagement Rate</th>
                                            }
                                            @if (isVisible('engagement_rate_organic')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Eng.
                                                Rate (Organic)</th>
                                            }
                                            @if (isVisible('engagement_rate_paid')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Eng.
                                                Rate (Paid)</th>
                                            }
                                            @if (isVisible('likes')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Likes
                                            </th>
                                            }
                                            @if (isVisible('likes_organic')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Likes
                                                (Organic)</th>
                                            }
                                            @if (isVisible('likes_paid')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Likes
                                                (Paid)</th>
                                            }
                                            @if (isVisible('comments')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Comments</th>
                                            }
                                            @if (isVisible('comments_organic')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Comments (Organic)</th>
                                            }
                                            @if (isVisible('comments_paid')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Comments (Paid)</th>
                                            }
                                            @if (isVisible('shares')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Shares
                                            </th>
                                            }
                                            @if (isVisible('shares_organic')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Shares
                                                (Organic)</th>
                                            }
                                            @if (isVisible('shares_paid')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Shares
                                                (Paid)</th>
                                            }
                                            <!-- Content Performance -->
                                            @if (isVisible('video_views')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Total
                                                Video Views</th>
                                            }
                                            @if (isVisible('video_views_organic')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Views
                                                (Organic)</th>
                                            }
                                            @if (isVisible('video_views_paid')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Views
                                                (Paid)</th>
                                            }
                                            @if (isVisible('average_view_time')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">Avg
                                                View Time</th>
                                            }
                                            @if (isVisible('average_view_time_organic')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">Avg
                                                View Time (Organic)</th>
                                            }
                                            @if (isVisible('average_view_time_paid')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">Avg
                                                View Time (Paid)</th>
                                            }
                                            @if (isVisible('video_completion_rate')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Completion Rate</th>
                                            }
                                            @if (isVisible('video_completion_rate_organic')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Completion Rate (Organic)</th>
                                            }
                                            @if (isVisible('video_completion_rate_paid')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Completion Rate (Paid)</th>
                                            }
                                            @if (isVisible('two_seconds_views')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">2s
                                                Views</th>
                                            }
                                            @if (isVisible('organic_two_seconds_views')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">2s
                                                Views (Organic)</th>
                                            }
                                            @if (isVisible('paid_two_seconds_views')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">2s
                                                Views (Paid)</th>
                                            }
                                            @if (isVisible('six_seconds_views')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">6s
                                                Views</th>
                                            }
                                            @if (isVisible('organic_six_seconds_views')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">6s
                                                Views (Organic)</th>
                                            }
                                            @if (isVisible('paid_six_seconds_views')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">6s
                                                Views (Paid)</th>
                                            }
                                            @if (isVisible('reach')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Reach
                                            </th>
                                            }
                                            @if (isVisible('reach_organic')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Reach
                                                (Organic)</th>
                                            }
                                            @if (isVisible('reach_paid')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Reach
                                                (Paid)</th>
                                            }
                                            @if (isVisible('total_play_time')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Total
                                                Play Time</th>
                                            }
                                            <!-- Ads Performance -->
                                            @if (isVisible('ad_cost')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">Ads
                                                Cost</th>
                                            }
                                            @if (isVisible('ad_clicks')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">Ad
                                                Clicks</th>
                                            }
                                            @if (isVisible('ad_conversions')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">Ad
                                                Conversions</th>
                                            }
                                            @if (isVisible('ad_cpa')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">CPA
                                            </th>
                                            }
                                            @if (isVisible('ad_cpc')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">CPC
                                            </th>
                                            }
                                            @if (isVisible('ad_cpm')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">CPM
                                            </th>
                                            }
                                            @if (isVisible('ad_ctr')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">CTR
                                            </th>
                                            }
                                            @if (isVisible('ad_cvr')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">CVR
                                            </th>
                                            }
                                            @if (isVisible('ad_impressions')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Impressions</th>
                                            }
                                            @if (isVisible('ad_roas')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                ROAS
                                            </th>
                                            }
                                            <!-- Audience -->
                                            @if (isVisible('audience_age_distribution')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">Age
                                                Distribution</th>
                                            }
                                            @if (isVisible('audience_countries_distribution')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Countries</th>
                                            }
                                            @if (isVisible('audience_device_distribution')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Devices
                                            </th>
                                            }
                                            @if (isVisible('audience_genders_distribution')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Gender
                                            </th>
                                            }
                                            @if (isVisible('audience_interest_distribution')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Interests</th>
                                            }
                                            @if (isVisible('audience_language_distribution')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Languages</th>
                                            }
                                            @if (isVisible('audience_locale_distribution')) {
                                            <th scope="col"
                                                class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                                Locale
                                            </th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (video of filteredVideos(); track video.video_info.video_id) {
                                        <tr (click)="videoForAnalysis.set(video)">
                                            <!-- Fixed: Thumbnail -->
                                            <td class="sticky left-0 z-10 bg-[var(--background)] border-r border-[var(--border)] px-3 py-2 flex flex-row items-center gap-x-2">
                                                <img [src]="video.video_info.thumbnail_url" alt="Video thumbnail"
                                                    class="h-16 aspect-9/16 object-cover rounded">
                                                    <div class="flex flex-col min-w-0">
                                                        <span class="text-sm font-medium text-primary truncate">{{
                                                            video.creator_info.display_name }}</span>
                                                        <span class="text-xs text-secondary truncate">{{
                                                            video.creator_info.handle_name }}</span>
                                                    </div>
                                            </td>
                                            <!-- Fixed: Creator -->
                                            <!-- <td class="px-3 py-2">
                                                <div class="flex flex-col min-w-0">
                                                    <span class="text-sm font-medium text-primary truncate">{{
                                                        video.creator_info.display_name }}</span>
                                                    <span class="text-xs text-secondary truncate">{{
                                                        video.creator_info.handle_name }}</span>
                                                </div>
                                            </td> -->
                                            <!-- Fixed: Create time -->
                                            <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                                video.video_info.create_time }}</td>
                                            <!-- Engagement -->
                                            @if (isVisible('engagement_count')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.engagement_count)
                                                }}</td>
                                            }
                                            @if (isVisible('engagement_rate')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.engagement_rate * 100 |
                                                number:'1.2-2' }}%</td>
                                            }
                                            @if (isVisible('engagement_rate_organic')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.engagement_rate_organic * 100 | number:'1.2-2' }}%</td>
                                            }
                                            @if (isVisible('engagement_rate_paid')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                (video.engagement_rate_paid ?? 0) * 100 | number:'1.2-2' }}%</td>
                                            }
                                            @if (isVisible('likes')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.likes) }}</td>
                                            }
                                            @if (isVisible('likes_organic')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.likes_organic) }}
                                            </td>
                                            }
                                            @if (isVisible('likes_paid')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.likes_paid ?
                                                formatService.convertIntToString(video.likes_paid) : '—'
                                                }}</td>
                                            }
                                            @if (isVisible('comments')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.comments) }}</td>
                                            }
                                            @if (isVisible('comments_organic')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.comments_organic)
                                                }}</td>
                                            }
                                            @if (isVisible('comments_paid')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.comments_paid ?
                                                formatService.convertIntToString(video.comments_paid) :
                                                '—' }}</td>
                                            }
                                            @if (isVisible('shares')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.shares) }}</td>
                                            }
                                            @if (isVisible('shares_organic')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.shares_organic) }}
                                            </td>
                                            }
                                            @if (isVisible('shares_paid')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.shares_paid ?
                                                formatService.convertIntToString(video.shares_paid) :
                                                '—' }}</td>
                                            }
                                            <!-- Content Performance -->
                                            @if (isVisible('video_views')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.video_views) }}
                                            </td>
                                            }
                                            @if (isVisible('video_views_organic')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.video_views_organic) }}</td>
                                            }
                                            @if (isVisible('video_views_paid')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.video_views_paid ? formatService.convertIntToString(video.video_views_paid)
                                                : '—' }}</td>
                                            }
                                            @if (isVisible('average_view_time')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.average_view_time)
                                                }}s</td>
                                            }
                                            @if (isVisible('average_view_time_organic')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.average_view_time_organic) }}s
                                            </td>
                                            }
                                            @if (isVisible('average_view_time_paid')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.average_view_time_paid) }}s</td>
                                            }
                                            @if (isVisible('video_completion_rate')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.video_completion_rate | number:'1.2-2' }}%</td>
                                            }
                                            @if (isVisible('video_completion_rate_organic')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.video_completion_rate_organic | number:'1.2-2' }}%</td>
                                            }
                                            @if (isVisible('video_completion_rate_paid')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.video_completion_rate_paid | number:'1.2-2' }}%</td>
                                            }
                                            @if (isVisible('two_seconds_views')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.two_seconds_views
                                                ? formatService.convertIntToString(video.two_seconds_views) : '—' }}
                                            </td>
                                            }
                                            @if (isVisible('organic_two_seconds_views')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.organic_two_seconds_views ? formatService.convertIntToString(video.organic_two_seconds_views) : '—' }}
                                            </td>
                                            }
                                            @if (isVisible('paid_two_seconds_views')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.paid_two_seconds_views ? formatService.convertIntToString(video.paid_two_seconds_views) : '—' }}</td>
                                            }
                                            @if (isVisible('six_seconds_views')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.six_seconds_views
                                                ? formatService.convertIntToString(video.six_seconds_views) : '—' }}
                                            </td>
                                            }
                                            @if (isVisible('organic_six_seconds_views')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.organic_six_seconds_views ? formatService.convertIntToString(video.organic_six_seconds_views) : '—' }}
                                            </td>
                                            }
                                            @if (isVisible('paid_six_seconds_views')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.paid_six_seconds_views ? formatService.convertIntToString(video.paid_six_seconds_views) : '—' }}</td>
                                            }
                                            @if (isVisible('reach')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.reach ?
                                                formatService.convertIntToString(video.reach) : '—' }}
                                            </td>
                                            }
                                            @if (isVisible('reach_organic')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.reach_organic
                                                ? formatService.convertIntToString(video.reach_organic) :
                                                '—' }}</td>
                                            }
                                            @if (isVisible('reach_paid')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{video.reach_paid ?
                                                formatService.convertIntToString(video.reach_paid) : '—'
                                                }}</td>
                                            }
                                            @if (isVisible('total_play_time')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.total_play_time
                                                }}s</td>
                                            }
                                            <!-- Ads Performance -->
                                            @if (isVisible('ad_cost')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.ad_cost |
                                                number:'1.2-2' }}</td>
                                            }
                                            @if (isVisible('ad_clicks')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.ad_clicks) }}</td>
                                            }
                                            @if (isVisible('ad_conversions')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                formatService.convertIntToString(video.ad_conversions) }}
                                            </td>
                                            }
                                            @if (isVisible('ad_cpa')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.ad_cpa |
                                                number:'1.2-2' }}</td>
                                            }
                                            @if (isVisible('ad_cpc')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.ad_cpc |
                                                number:'1.2-2' }}</td>
                                            }
                                            @if (isVisible('ad_cpm')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.ad_cpm |
                                                number:'1.2-2' }}</td>
                                            }
                                            @if (isVisible('ad_ctr')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.ad_ctr |
                                                number:'1.2-2' }}%</td>
                                            }
                                            @if (isVisible('ad_cvr')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.ad_cvr |
                                                number:'1.2-2' }}%</td>
                                            }
                                            @if (isVisible('ad_impressions')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{
                                                video.ad_impressions }}
                                            </td>
                                            }
                                            @if (isVisible('ad_roas')) {
                                            <td class="px-3 py-2 text-sm text-right text-primary">{{ video.ad_roas |
                                                number:'1.2-2' }}</td>
                                            }
                                            <!-- Audience (distribution — placeholder until richer display is designed) -->
                                            @if (isVisible('audience_age_distribution')) {
                                            <td class="px-3 py-2 text-sm text-right text-secondary">—</td>
                                            }
                                            @if (isVisible('audience_countries_distribution')) {
                                            <td class="px-3 py-2 text-sm text-right text-secondary">—</td>
                                            }
                                            @if (isVisible('audience_device_distribution')) {
                                            <td class="px-3 py-2 text-sm text-right text-secondary">—</td>
                                            }
                                            @if (isVisible('audience_genders_distribution')) {
                                            <td class="px-3 py-2 text-sm text-right text-secondary">—</td>
                                            }
                                            @if (isVisible('audience_interest_distribution')) {
                                            <td class="px-3 py-2 text-sm text-right text-secondary">—</td>
                                            }
                                            @if (isVisible('audience_language_distribution')) {
                                            <td class="px-3 py-2 text-sm text-right text-secondary">—</td>
                                            }
                                            @if (isVisible('audience_locale_distribution')) {
                                            <td class="px-3 py-2 text-sm text-right text-secondary">—</td>
                                            }
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    @if (videoForAnalysis()) {
        <ttor-video-analysis [video]="videoForAnalysis()!" (close)="videoForAnalysis.set(undefined)"></ttor-video-analysis>
    }